import React from 'react';
import SiteLayout from '../../site/SiteLayout';
import ScheduleCall from '../../site/ScheduleCall/ScheduleCall';
import Hero from '../Hero/Hero';
import Mission from '../Mission/Mission';
import FounderMessage from '../FounderMessage/FounderMessage';
import InvestmentOptions from '../InvestmentOptions/InvestmentOptions';
import InvestmentProcess from '../InvestmentProcess/InvestmentProcess';
import ClientStories from '../ClientStories/ClientStories';
import Insights from '../Insights/Insights';

const LandingPage = () => (
  <SiteLayout>
    <Hero />
    <Mission />
    <FounderMessage />
    <InvestmentOptions />
    <InvestmentProcess />
    <ClientStories />
    <Insights />
    <ScheduleCall />
  </SiteLayout>
);

export default LandingPage;
